<div data-cy="confirmation-dialog__page" class="main">
    <div>
      <h4 class="title">{{ title | capitaliz }}</h4>
    </div>
  
    <div class="popup-body">
      {{ message }}
    </div>
  
    <div class="popup-footer">
      <div class="dialog-button-row">
        <button data-cy="confirmation-dialog__submit-btn" type="button" mat-stroked-button (click)="submit(false)">
          {{ cancelText | capitaliz }}
        </button>
        <button data-cy="confirmation-dialog__btn"
          type="button"
          class="btn mdl-button mat-flat-button mdl-js-button mdl-button--raised btn-danger"
          (click)="submit(true)"
        >
          {{ confirmText | capitaliz }}
        </button>
      </div>
    </div>
  </div>
  